import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { assignMessage } from 'src/app/constants/service.constants';

@Component({
  selector: 'app-assign-dialog',
  templateUrl: './assign-dialog.component.html',
  styleUrls: ['./assign-dialog.component.scss']
})
export class AssignDialogComponent implements OnInit {

  heading: string;
  content: any;
  assignMessage = assignMessage;

  assignUser = new UntypedFormGroup({
    user: new UntypedFormControl('', Validators.required)
  })

  users = [
    {value:'1',label:'Venkat'},
    {value:'2',label:'Gopi'},
    {value:'3',label:'Siva'},
    {value:'4',label:'Upendra'},
  ] 

  constructor(public modalRef: NgbActiveModal) {}


  ngOnInit() {
    if(this.content && this.content.users)
      this.users = this.content['users'];
  }

}
